const DestinationMarkerSvg = ({
  width = 18,
  height = 24,
  bgColor = 'black',
}: {
  width?: number;
  height?: number;
  bgColor?: string;
}) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 27 36' fill='none'>
    <path
      d='M26.5 13.5C26.5 14.9379 26.0153 16.7014 25.1976 18.6383C24.3834 20.5669 23.2563 22.628 22.0102 24.6493C19.5183 28.6916 16.5744 32.537 14.776 34.7876C14.1114 35.6133 12.8886 35.6133 12.224 34.7876C10.4256 32.537 7.4817 28.6916 4.98978 24.6493C3.74367 22.628 2.61658 20.5669 1.8024 18.6383C0.984727 16.7014 0.5 14.9379 0.5 13.5C0.5 6.32302 6.32302 0.5 13.5 0.5C20.677 0.5 26.5 6.32302 26.5 13.5Z'
      fill={bgColor}
      stroke='white'
    />
  </svg>
);

export default DestinationMarkerSvg;
